import ShoppingBagOutlined from "@mui/icons-material/ShoppingBagOutlined";
import { Typography, CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import ShoppingBag from "components/ShoppingBag";
import { useState } from "react";
import { Fonts } from "helpers/Consts";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import IfElseComponent from "../IfElseComponent";
import { ICardapioAppState } from "../../redux/RootReducer";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";

type Props = {
  isShoppingBagRefetching:boolean;
  isShoppingBagLoading:boolean;
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
};

function BottomShopBag({isShoppingBagRefetching, isShoppingBagLoading, shoppingBagQuery}:Props) {

  const [searchParams, setSearchParams] = useSearchParams();
  const shopping_bag_open = searchParams.get("shopping_bag_open");
  const [open, setOpen] = useState<boolean>(shopping_bag_open==="true");

  const toggleDrawer = () => {
    // console.log("toggleDrawer on BottomShopBag");
    const obj = Object.fromEntries( searchParams.entries() );
    obj.shopping_bag_open = (!open).toString();
    setSearchParams(obj);
    setOpen(!open);
  };
  return (
  <Box>
      <ShoppingBag open={open} toggleDrawer={toggleDrawer} anchor="bottom" shoppingBagQuery={shoppingBagQuery}/>
    <IfElseComponent
      condition={isShoppingBagRefetching || isShoppingBagLoading }
      ifComponent={(<Box
          sx={{
            display: "flex",
            backgroundColor: "red",
            color: "white",
            height: "60px",
            alignItems: "center",
            padding: "10px",
          }}
          onClick={() => {
            toggleDrawer();
          }}
      >
        <ShoppingBagOutlined fill="#fff" />
        <Box sx={{ flexGrow: 2 }} />
        <Typography fontWeight={700}>
          {(isShoppingBagRefetching && !isShoppingBagLoading? 'Atualizando sacola...' : '')}
          {(isShoppingBagLoading && !isShoppingBagRefetching ? 'Carregando sacola...' : '')}
          {(isShoppingBagLoading && isShoppingBagRefetching ? 'Carregando sacola....' : '')}

        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <CircularProgress />
        <Box sx={{ flexGrow: 2 }} /></Box>)}
      elseComponent={(<Box
        sx={{
          display: "flex",
          backgroundColor: "red",
          color: "white",
          height: "60px",
          alignItems: "center",
          padding: "10px",
        }}
        onClick={() => {
          toggleDrawer();
        }}
      >
        <ShoppingBagOutlined fill="#fff" />
        <Box sx={{ flexGrow: 1 }} />
        <Typography fontWeight={700}>Ver sacola</Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Typography fontWeight={700} fontFamily={Fonts.fontStyleBold}>
          {!shoppingBagQuery.data ? '' :  shoppingBagQuery.data.total.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })}
        </Typography>
      </Box>)}
    />
    </Box>
  );
}

export default BottomShopBag;
